import script from "./Tab.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tab.vue?vue&type=script&setup=true&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=f8f22776&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8f22776"]])

export default __exports__